export const wineListEn = {
  hero: {
    title: 'Wine List',
    subtitle: 'A curated selection of exceptional Italian wines',
  },
  description:
    "Our wine list features a carefully curated selection of wines from Italy's finest regions, with an emphasis on smaller family-owned vineyards that practice sustainable viticulture.",
  subCategories: {
    'Soda & juices': 'Soda & Juices',
    'Draft beer': 'Draft Beer',
    'Bottled beer': 'Bottled Beer',
    Cocktails: 'Cocktails',
    Coffee: 'Coffee',
    Liquors: 'Liquors',
    Snaps: 'Snaps',
    'Alcoholic Coffee drinks': 'Alcoholic Coffee Drinks',
  },
  pairing: {
    title: 'Wine Pairing Suggestions',
    description:
      "Our staff is always happy to recommend the perfect wine pairing for your meal. Don't hesitate to ask your server for suggestions!",
    categories: [
      {
        title: 'With Pizza',
        description: 'Chianti Superiore, Valpolicella, or a crisp Pinot Grigio',
      },
      {
        title: 'With Pasta',
        description: 'Amarone with rich meat sauces, Soave with seafood pastas',
      },
      {
        title: 'With Dessert',
        description: 'Prosecco with fruit desserts, Tosti Rosé with chocolate',
      },
    ],
  },
  categories: {
    white: 'White Wine',
    rose: 'Rosé',
    sparkling: 'Sparkling',
    champagne: 'Champagne',
    red: 'Red Wine',
    beverages: 'Beverages',
  },
  items: {
    1: {
      name: 'Frescobaldi, Attems Chardonnay',
      region: 'Italy – Venezia Giulia',
      description:
        'Rich and entertaining filling, combines fruit notes of white figs, quince, mandarin, hints of toasted bread, pine nuts and spiced vanilla. The wine is soft with a long fruity finish.',
    },
    2: {
      name: 'Frescobaldi, Rémole Bianco',
      region: 'Italy – Toscana IGT',
      description:
        'Vermentino & Trebbiano, fresh blend characterized by flowers, yellow apples, melon and star fruit.',
    },
    3: {
      name: 'Van Gogh Riesling',
      region: 'Germany – Mosel',
      description: 'Fresh Riesling with flavors of green apples, apricots and peaches.',
    },
    4: {
      name: 'Las Moras Sauvignon Blanc',
      region: 'Argentina - San Juan',
      description:
        'Fresh fruit tones of grapefruit with a hint of asparagus, dry with fresh citrus.',
    },
    5: {
      name: 'Allegrini Soave D.O.C.',
      region: 'Italy – Veneto',
      description: 'Fresh fruit, jasmine and citrus, dry with fresh citrus.',
    },
    6: {
      name: 'Villa Lucia Pinot Grigio',
      region: '',
      description: 'Lively and tasty with good fruit. Everything a good wine needs to have.',
    },
    7: {
      name: 'Faustino VII',
      region: 'Spain',
      description:
        'Powerful aroma of strawberries and blackberries, fruity and fresh in the mouth with entertaining Tempranillo influences.',
    },
    8: {
      name: 'Frescobaldi, Tenuta Ammiraglia Alíe',
      region: 'Italy – Toscana',
      description:
        'Beautifully light pink and silky smooth with fruit notes of peach, white fruit, aromatic herbs and citrus.',
    },
    9: {
      name: 'Tosti Prosecco Rosé',
      region: 'Italy – Piedmonte',
      description:
        'Dry fine sparkling, fresh acidity with fruit, raspberry, flowers and apple skin.',
    },
    10: {
      name: 'Tosti Prosecco',
      region: 'Italy – Piedmonte',
      description: 'Golden. Dry, light sparkling, fresh acidity. Light fruit, apple core.',
    },
    11: {
      name: 'Bollinger Special Cuveé',
      region: 'France – Champagne',
      description:
        'Light golden. Good filling, dry and fresh with broad aroma, cocoa, citrus fruit, apple and peach plus skin and yeast tones.',
    },
    12: {
      name: 'Chianti Superiore Poggie Al Casone',
      region: 'Italy – Toscana',
      description: 'Ruby red with floral and cherry aroma. Mild finish with cherries and mild oak.',
    },
    13: {
      name: 'Tenuta Frescobaldi Castiglioni',
      region: 'Italy – Toscana IGT',
      description: 'Cabernet Sauvignon, Merlot, Cabernet Franc and Sangiovese.',
    },
    14: {
      name: 'Allegrini Valpolicella Classico',
      region: 'Italy – Veneto D.O.C.',
      description: 'Fresh with cherries and herbs, dry velvet smooth.',
    },
    15: {
      name: 'Louis Latour Bourgogne Rouge Cuvée Latour',
      region: 'France – Bourgogne',
      description: 'Pinot Noir with cherry, strawberry and dry finish',
    },
    16: {
      name: 'Amarone Della Valpolicella',
      region: 'Italy – Veneto D.O.C.G.',
      description:
        'Powerful tones of ripe dark fruit, powerful in the mouth and silky smooth tannins.',
    },
    17: {
      name: 'Las Moras Black Label Malbec',
      region: 'Argentina – San Juan',
      description:
        'Deep fruit of ripe plums, roasted coffee and chocolate. Soft tannins and light oak.',
    },
    18: {
      name: 'Baffo Rosso Chianti',
      region: '',
      description: 'Dry Chianti, light tannins with fresh unripe forest berries.',
    },
  },
};
